import { useState } from 'react';
import * as React from 'react'
import { Flashbar } from '@amzn/awsui-components-react-v3';
import { Item } from '../models/item-model';
import { Message } from '../models/item-detail-model';
import { submitItem } from '../actions/async.action';
import { useDispatch } from 'react-redux';
import { fetchItems } from '../reducers/ItemsSlice';

const bcItemCreate = [
    {
        "text": "Home",
        "href": "#"
    },
    {
        "text": "Create Item",
        "href": "",
    },
]

const useItemCreate = () => {
    const dispatch = useDispatch();

    const [itemInfo, setItemInfo] = useState(Item.Data.getDefaultData());
    const [errorMessages, setErrorMessages] = useState([])
    const [loading, setLoading] = useState(true)
    const [showError, setShowError] = useState(false)
    const [itemId, setItemId] = useState("")

    const onItemInfoChange = async (updateItemInfo) => {
        setItemInfo(
            {
                ...itemInfo,
                ...updateItemInfo,
            }
        );
    }

    const onNewSubmit = () => {
        const newItem = {
            ...itemInfo
        }
        delete newItem.QA
        submitItem(newItem)
            .then((res) => {
                setItemId(res.data.Id)
                setLoading(false)
                // Refresh the items list in Redux store after successful creation
                dispatch(fetchItems())
            })
            .catch((error) => {
                // error.response is undefined for network errors/timeouts, and errors may be missing on 5xx
                const errors = error?.response?.data?.errors
                console.log(error?.response?.data ?? error)
                setShowError(true)
                setErrorMessages(Array.isArray(errors) && errors.length > 0
                    ? errors
                    : [{ type: 'error', field: 'banner', message: 'Submit failed, please try again.' }])
            })
    };

    const displayMessages = (error: Message[]) => {
        if (error.length > 0) {
            let bannerErrors = error.filter((e) => e.field === 'banner');
            if (bannerErrors.length) {
                return <Flashbar items={bannerErrors.map((e) => {return {type: e.type, dismissible: true, header: e.message}})} />
            }
        }
    }

    const flashMessages = (
        <div>
            {displayMessages(errorMessages)}
        </div>)


    return {
        itemInfo,
        loading,
        showError,
        flashMessages,
        errorMessages,
        bcItemCreate,
        setErrorMessages,
        setShowError,
        setLoading,
        onItemInfoChange,
        onNewSubmit,
        itemId,
    };
}

export default useItemCreate